module.exports = __webpack_public_path__ + "img/attire_logo.42a651f2.png";